import { Button } from "@payping/web-components";
import { Close } from "@payping/icons";
import React from "react";
import { useLastUrlWasPage } from "@/utils";

type Props = {
  setIsDrawerOpen: (value: boolean) => void;
};
const DrawerCloseButton: React.FC<Props> = ({ setIsDrawerOpen }) => {
  const { navigateToLast } = useLastUrlWasPage();

  return (
    <Button
      type={"text"}
      icon={<Close width={14} height={14} />}
      onClick={() => {
        setIsDrawerOpen(false);
        // I tested it : if you put lower number you will not see the closing animation of drawer
        // I tested until 66 then i put it on 100
        // you can always change this if you found better solution ...
        setTimeout(() => {
          navigateToLast();
        }, 100);
      }}
    />
  );
};

export default DrawerCloseButton;
